import React from 'react';

import Spinner from './Spinner';

import useCheckoutState, { checkoutStates } from '../hooks/useCheckoutState';

import ChargeStatusMessage from './ChargeStatusMessage';

export default function CheckoutFormContainer({ children }) {
  const { state, checkout, seller, payment } = useCheckoutState();

  const showCheckout =
    state === checkoutStates.INITIAL ||
    state === checkoutStates.CREATING_PAYMENT ||
    state === checkoutStates.CREATING_SUBSCRIPTION ||
    state === checkoutStates.CREATING_SUBMISSION ||
    state === checkoutStates.SUBMITTING ||
    state === checkoutStates.COMPLETED;

  const showSpinner = state === checkoutStates.PROCESSING_PAYMENT;
  const showPending = state === checkoutStates.PENDING;
  const showError = state === checkoutStates.ERROR;

  if (showCheckout) {
    return children;
  }

  if (showError) {
    return (
      <ChargeStatusMessage seller={seller} checkout={checkout} payment={payment} status="failed" />
    );
  }

  if (showPending) {
    return (
      <ChargeStatusMessage seller={seller} status="pending" checkout={checkout} payment={payment} />
    );
  }

  if (showSpinner) {
    return (
      <div className="cp_processing-wrapper flex flex-col text-center justify-center items-center p-4">
        <h2 className="cp_processing-title text-black mb-4">{checkout.processingPaymentText}</h2>

        <Spinner className="cp_spinner" />
      </div>
    );
  }

  return null;
}
